import { CustomNavBarMenu } from "../models/nav-bar.model";

export const CUSTOM_NAVBAR_MENU: CustomNavBarMenu[] = [
    {
        title: 'dashboard',
        icon: 'dashboard-side',
        routerLinkUrl: '/myTask'
    },
    {
        title: 'cadreManagement',
        icon: 'cadre-side',
        dropDownList: [
            {
                title: 'Profile Review',
                routerLinkUrl: 'profileReview'
            },
            {
                title: "Assigned Activity",
                routerLinkUrl: 'activities/list/assigned'
            },
            {
                title: "plannedActivity",
                routerLinkUrl: 'activities/list/planned'
            },
            {
                title: 'payments',
                routerLinkUrl: 'payments'
            }
        ]
    },
    {
        title: 'master',
        icon: 'master-side',
        dropDownList: [
            {
                title: 'geographyMaster',

                routerLinkUrl: '/geography-master/geography-master'
            },
            {
                title: 'role',
                routerLinkUrl: '/roles/roles'
            },
            {
                title: 'thematics',
                routerLinkUrl: '/thimatic/thimatic'
            },
            {
                title: 'profileReview',
                routerLinkUrl: 'profileReview'
            },
            {
                title: "assignedActivity",
                routerLinkUrl: 'assignedActivity'
            },
            {
                title: "plannedActivity",
                routerLinkUrl: 'plannedActivity'
            },
            {
                title: 'payments',
                routerLinkUrl: 'payments'
            },
            
        ]
    }
];